import BackButton from '@components/common/back-button';
import { reportsPage } from '@constants/images';
import { useTranslation } from 'react-i18next';

const ReportsHeader = () => {
  const { t: translate } = useTranslation();
  return (
    <div className="relative rounded-b-2xl bg-header-grey px-4 py-3 md:rounded-none">
      <BackButton />
      <img
        src={reportsPage.header.barChart}
        alt="bar-chart"
        className="absolute bottom-0 right-3"
      />
      <div className="relative mb-2 mt-3 flex flex-col gap-3 md:mt-0 md:flex-row md:items-center md:justify-between">
        <div>
          <h2 className="font-frcondensed text-xl font-semibold text-white">
            {translate(`reports.reports`)}
          </h2>
          <p className="font-frcondensed text-xs text-grey-subheader">
            List of all the reports
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReportsHeader;
